import { defaultFill } from '../utils/constants';
var muiPlusGlyph = {
    paths: [
        {
            path: 'M8,0.502004755 C8.55228475,0.502004755 9,0.949720005 9,1.50200475 L9,1.50200475 L9,7.50200475 L15,7.50200475 C15.5128358,7.50200475 15.9355072,7.88804494 15.9932723,8.38538363 L16,8.50200475 C16,9.0542895 15.5522847,9.50200475 15,9.50200475 L15,9.50200475 L9,9.50200475 L9,15.5020048 C9,16.0148406 8.61395981,16.4375119 8.11662113,16.495277 L8,16.5020048 C7.44771525,16.5020048 7,16.0542895 7,15.5020048 L7,15.5020048 L7,9.50200475 L1,9.50200475 C0.487164161,9.50200475 0.0644928393,9.11596456 0.00672773133,8.61862588 L0,8.50200475 C0,7.94972 0.44771525,7.50200475 1,7.50200475 L1,7.50200475 L7,7.50200475 L7,1.50200475 C7,0.989168915 7.38604019,0.566497594 7.88337887,0.508732486 Z',
            fill: defaultFill,
        },
    ],
    title: 'Plus',
    width: 16,
    height: 17,
};
var muiPlus = {
    base: muiPlusGlyph,
};
export { muiPlus };
//# sourceMappingURL=plus.js.map